// Current version
export const g_version = 'v0.12.22-695e073';

// Display the version string in the console
console.log(g_version);
